import React from 'react';

const TopIcon = () => {
  return (
    <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium h-4 w-4 text-gray-600 css-vubbuv" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="LandscapeOutlinedIcon"><path d="m14 6-4.22 5.63 1.25 1.67L14 9.33 19 16h-8.46l-4.01-5.37L1 18h22L14 6zM5 16l1.52-2.03L8.04 16H5z"></path></svg>
  );
};
export default TopIcon;